import ICONS from "../../../../assets/icons";
import React from "react";
import _ from 'lodash';
import IReactive from '../../../interfaces/reactiveJob'
import PlannedJob from "../../../interfaces/plannedJob";

const reactiveList ={
  new: {
    count: 0,
    title: 'NEW JOBS',
    icon: <ICONS.star />,
  },
  allocated: {
    count: 0,
      title: 'ALLOCATED',
    icon: <ICONS.user />,
  },
  inProgress: {
    count: 0,
    title: 'IN PROGRESS',
    icon: <ICONS.loader />,
  },
  onHold: {
    count: 0,
    title: 'ON HOLD',
    icon: <ICONS.pauseCircle />,
  },
  cancelled: {
    count: 0,
    title: 'CANCELLED',
    icon: <ICONS.xCircle />,
  },
  workCompleted: {
    count: 0,
    title: 'WORK COMPLETED',
    icon: <ICONS.check />,
  },
  finished: {
    count: 0,
    title: 'FINISHED',
    icon: <ICONS.checkCircle/>
  }
};

const plannedList = {
  'Open':{
    count: 0,
    title: 'OPEN',
    status: 'open',
    icon: <ICONS.arrowUpRight />,
  },
  'Completed': {
    count: 0,
    title: 'COMPLETED',
    status: 'completed',
    icon: <ICONS.checkCircle />,
  },
  'Incomplete': {
    count: 0,
    title: 'INCOMPLETE',
    status: 'incomplete',
    icon: <ICONS.x />,
  }
};

export const computeSummaryData = (jobs: IReactive[] | PlannedJob[], type: string) => {
  let summaryData;

  if (type == 'reactive') {
    summaryData = _.cloneDeep(reactiveList);
  } else {
    summaryData = _.cloneDeep(plannedList);
  }

  jobs.map((job: IReactive | PlannedJob) => {
    summaryData[job.Status].count += 1;
  });

  return summaryData
};